import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import { useNavigate } from "react-router-dom";

export default function AnchorTemporaryDrawer() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (isOpen) => () => setOpen(isOpen);
  const navigate = useNavigate();

  const drawerContent = (
    <Box
      sx={{
        width: 300,
        height: "100%",
        bgcolor: "white",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        p: 3,
        textAlign: "right",
      }}
      role="presentation"
    >
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <IconButton onClick={toggleDrawer(false)}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Navigation */}
      <Box sx={{ flexGrow: 1 }}>
        <Typography
          variant="h6"
          sx={{ my: 2, fontWeight: 500, color: "#1a311a", cursor: "pointer" }}
          onClick={() => navigate("/oryza")}
        >
          ORZYA LEISURE
        </Typography>
        <Typography
          variant="h6"
          sx={{ my: 2, fontWeight: 500, color: "#1a311a", cursor: "pointer" }}
          onClick={() => navigate("/oryza")}
        >
          DESTINATIONS
        </Typography>
        <Typography
          variant="h6"
          sx={{ my: 2, fontWeight: 500, color: "#1a311a", cursor: "pointer" }}
          onClick={() => navigate("/oryza")}
        >
          OFFERS
        </Typography>
        <Typography
          variant="h6"
          sx={{ my: 2, fontWeight: 500, color: "#1a311a", cursor: "pointer" }}
          onClick={() => navigate("/oryza-countactus")}
        >
          CONTACT US
        </Typography>
      </Box>

      {/* Socials + Footer */}
      <Box>
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mb: 2 }}
        >
          <FacebookIcon />
          <InstagramIcon />
        </Box>
        <Typography variant="body2" sx={{ fontSize: "12px", color: "#555" }}>
          © 2024 Oryza Leisure. All rights reserved.
          <br />
          Designed and Developed by <strong>Ollcode</strong>
        </Typography>
      </Box>
    </Box>
  );

  return (
    <>
      <button
        onClick={toggleDrawer(true)}
        style={{ color: "white", border: "none" }}
      >
        <span style={{ color: "white" }}>☰</span>
      </button>
      <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
        {drawerContent}
      </Drawer>
    </>
  );
}
